import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import Tick from '@atlaskit/icon/glyph/check-circle';
import { Box } from '@atlaskit/primitives';
import { G300 } from '@atlaskit/theme/colors';
import { FLAG_DISMISSED } from '../../common/constants';
import { useACTAnalyticsEvents } from '../../common/utils';
import { useAdControlProvider } from '../../controllers';
import { messages } from '../messages';
import { overridePortalIndex } from '../utils';
const ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const interactedUIEventAction = {
  action: 'clicked',
  actionSubject: 'button',
  actionSubjectId: 'adControlsFlagClose'
};
const DismissalFlagGroup = () => {
  overridePortalIndex(ACT_FLAG_WRAPPER);
  const {
    state: {
      flags
    },
    createEventDispatcher
  } = useAdControlProvider();
  const {
    createInteractedUIEvent
  } = useACTAnalyticsEvents();
  const handleOnDismissed = React.useCallback(id => {
    createEventDispatcher(id).dispatch(FLAG_DISMISSED, createInteractedUIEvent(interactedUIEventAction));
  }, [createEventDispatcher, createInteractedUIEvent]);
  return /*#__PURE__*/React.createElement(FlagGroup, {
    onDismissed: handleOnDismissed
  }, Array.from(flags.entries()).map(([itemId, {
    actions = [],
    ...flagProps
  } = {
    actions: []
  }], i) => /*#__PURE__*/React.createElement(Box, {
    key: i,
    id: ACT_FLAG_WRAPPER
  }, /*#__PURE__*/React.createElement(AutoDismissFlag, _extends({
    id: itemId,
    testId: `act-flag-${itemId}`,
    icon: /*#__PURE__*/React.createElement(Tick, {
      label: "Success",
      primaryColor: `var(--ds-icon-success, ${G300})`
    }),
    title: /*#__PURE__*/React.createElement(FormattedMessage, messages.notInterestedFlag),
    description: /*#__PURE__*/React.createElement(FormattedMessage, messages.dismissalMessage)
  }, flagProps, {
    actions: actions.map(action => ({
      ...action,
      onClick: e => {
        var _action$onClick;
        (_action$onClick = action.onClick) === null || _action$onClick === void 0 ? void 0 : _action$onClick.call(action, e, () => handleOnDismissed(itemId));
      }
    }))
  })))));
};
export default DismissalFlagGroup;